import config from './config';
import settings from './settings';

export default {
    config,
    settings,
};
